import { render, staticRenderFns } from "./SlrcRD.vue?vue&type=template&id=41c8568c"
import script from "./SlrcRD.vue?vue&type=script&lang=js"
export * from "./SlrcRD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports